import React from "react";

export default function ML_Data() {
  return (
    <div>
      <h1>ML_Data</h1>
      <p>This is the ML_Data component.</p>
    </div>
  );
}
